export const applyBtnText = "Same set up for all files";
export const applyTooltipText = "Settings will be copy from the 1st file";
